export default __webpack_public_path__ + "static/media/frame_person.bf800400.svg";